import NiceModal, { useModal } from '@ebay/nice-modal-react';
import 'swiper/css';
import 'swiper/css/pagination';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { ContentWrapper } from './FeatureBreakdownModal.styled';
import * as S from './OTOModules.styled';

const UpgradePlanSuccessModal = NiceModal.create((props) => {
	const { image, title } = props;
	const modal = useModal();

	return (
		<Modal maxWidth="small" fullwidth className="feature-breakdown-modal" closeButton={true}>
			<ModalTitle>
				<Typography variant="p1">activateModules</Typography>
			</ModalTitle>
			<ModalContent>
				<ContentWrapper>
					<S.SuccessModalContainer>
						<S.PackageItemImage>
							<Image url={image} width="9rem" height="9rem" />
						</S.PackageItemImage>
						<S.SuccessModalTextWrapper>
							<Typography noWrap variant="p1" fontWeight="500">
								{title}
							</Typography>
							<Typography noWrap color="var(--content-3)" variant="p2">
								activateModules.description
							</Typography>
						</S.SuccessModalTextWrapper>
					</S.SuccessModalContainer>
				</ContentWrapper>
			</ModalContent>
			<ModalActions>
				<Button
					size="large"
					icon={faCheck}
					onClick={() => {
						modal.resolve({ activate: true });
						modal.remove();
					}}
					label="activateModules.button"
				/>
			</ModalActions>
		</Modal>
	);
});

export default UpgradePlanSuccessModal;
